import { render, staticRenderFns } from "./PriceOnePoint.vue?vue&type=template&id=16e36680&"
import script from "./PriceOnePoint.vue?vue&type=script&lang=js&"
export * from "./PriceOnePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../.yarn/$$virtual/vue-loader-virtual-2de03e72fd/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../.yarn/$$virtual/vuetify-loader-virtual-84a97e788a/0/cache/vuetify-loader-npm-1.7.2-d296a16f38-4e4fb2ed10.zip/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VAvatar,VChip,VCol,VCombobox,VDataTable,VEditDialog,VIcon,VLayout,VRow,VTextField})
